import * as React from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';

interface Column {
  id: 'kaardi_nr' | 'kaardi_piirkond' | 'kapitali_suurus' | 'kapitali_valuuta_tekstina' | 'algus_kpv' | 'lopp_kpv';
  label: string;
  minWidth?: number;
  align?: 'right';
  format?: (value: number) => string;
}

const columns: readonly Column[] = [
  { id: 'kaardi_nr', label: 'Card Number', minWidth: 100 },
  { id: 'kaardi_piirkond', label: 'Region', minWidth: 100, align: 'right' },
  { id: 'kapitali_suurus', label: 'Capital Size', minWidth: 150, align: 'right' },
  { id: 'kapitali_valuuta_tekstina', label: 'Currency', minWidth: 100, align: 'right' },
  {
    id: 'algus_kpv',
    label: 'Start Date',
    minWidth: 150,
    align: 'right',
    format: (value: number) => new Date(value * 1000).toLocaleDateString(),
  },
  {
    id: 'lopp_kpv',
    label: 'End Date',
    minWidth: 150,
    align: 'right',
    format: (value: any) => (typeof value === 'number' ? new Date(value * 1000).toLocaleDateString() : 'N/A'),
  },
];

interface KapitalidItem {
  kaardi_nr: number;
  kaardi_piirkond: number;
  kapitali_suurus: number;
  kapitali_valuuta_tekstina: string;
  algus_kpv: number;
  lopp_kpv: number | string;
}

interface CapitalTableProps {
  rows: KapitalidItem[];
}

export default function CapitalTable({ rows }: CapitalTableProps) {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
      <TableContainer sx={{ maxHeight: 440 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row) => {
                return (
                  <TableRow hover role="checkbox" tabIndex={-1} key={row.kaardi_nr}>
                    {columns.map((column) => {
                      const value = row[column.id as keyof KapitalidItem];
                      return (
                        <TableCell key={column.id} align={column.align}>
                          {column.format && typeof value === 'number'
                            ? column.format(value)
                            : value}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  );
}